<template>
  <div class="gp-content">
   <p>AdminDashBoardIndex</p>
  </div>
</template>

<script>
export default {
  name: 'AdminDashBoardIndex',
  components: { },
  computed: { },
};
</script>
